/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */
export interface IPackageListingAppBaseSettings {
    numberOfPerformancesToDisplayByDefault: number;
    configId: number
    // Not from api but ~about~ api
    requesting: boolean;
    useUnseatedReservation: boolean;
    isFixed: boolean;
    apiError: any;
    smartSeatUrl: string;
    isRenewal: boolean;
}


export const defaultBaseSettings: IPackageListingAppBaseSettings = {
    numberOfPerformancesToDisplayByDefault: 0,
    configId: 0,
    useUnseatedReservation: false,
    isFixed: false,
    requesting: false,
    apiError: null,
    smartSeatUrl: "",
    isRenewal: false
}